<ra-modal
    [title]="'order.trashPanel.title' | translate"
    [animation]="'slide-right'"
    (close)="close.emit()">

    @if (loading()) {
        <div class="container-loading">
            <ra-loading [size]="'small'" />
        </div>
    }
    @else if (!items().length) {
        <ra-empty
            [title]="'order.trashPanel.emptyTitle' | translate"
            [message]="'order.trashPanel.emptyMessage' | translate"
        />
    }
    @else {
        <p class="ra-label-xs content-secondary trash-hint">
            {{ 'order.trashPanel.hint' | translate }}
        </p>

        <div class="container-search">
            <ra-input
                [id]="'input-search-trash'"
                [placeholder]="'order.trashPanel.searchPlaceholder' | translate"
                [formControl]="searchControl"
                [showRequiredOrOptional]="false"
            />
        </div>

        @if (!filteredItems().length) {
            <ra-empty
                [marginTop]="24"
                [message]="'order.trashPanel.searchEmpty' | translate"
            />
        }

        <div class="container-trash-list">
            @for (item of filteredItems(); track item._id) {
                <div class="trash-row">
                    <span
                        class="trash-row__icon"
                        [class.trash-row__icon--group]="item.type === feedItemTypeEnum.GROUP"
                        [class.trash-row__icon--document]="item.type === feedItemTypeEnum.DOCUMENT">
                        <ra-icon
                            [icon]="item.type === feedItemTypeEnum.GROUP ? 'folder' : 'file'"
                            varColor="contentInverse"
                            [size]="16"
                        />
                    </span>

                    <div class="trash-row__info">
                        <p class="ra-label-s bold">{{ itemTitle(item) }}</p>
                        <p class="ra-label-xs content-secondary">
                            <!-- Título é o cliente; a descrição (se houver) vira subtítulo -->
                            @if (item.type === feedItemTypeEnum.GROUP && item.description?.trim()) {
                                {{ item.description }} ·
                            }
                            <!-- ≤ 5 dias para o expurgo: prazo em vermelho (danger) -->
                            <span class="trash-row__expires" [class.danger]="isExpiringSoon(item)">
                                {{ 'order.trashPanel.expiresIn' | translate: { days: expiresInDays(item) } }}
                            </span>
                        </p>
                    </div>

                    <!-- Código da OS: só o grupo tem um; o avulso mora numa order
                         pessoal, cujo código não diz nada ao usuário. -->
                    @if (item.type === feedItemTypeEnum.GROUP && item.code) {
                        <ra-badge
                            [label]="'order.common.codeLabel' | translate: { code: item.code }"
                            [variant]="'primary'"
                            [size]="'small'"
                        />
                    }

                    @if (restoringId() === item._id) {
                        <ra-loading [size]="'small'" />
                    }
                    @else {
                        <ra-square-icon
                            [id]="'square-icon-trash-restore-' + item._id"
                            [icon]="'rotate-right'"
                            [tooltip]="'order.trashPanel.restoreTooltip' | translate"
                            [tooltipPosition]="'left'"
                            (click)="restore(item)"
                        />
                    }
                </div>
            }
        </div>
    }
</ra-modal>
